import commonStore from './commonStore';
import generatorStore from './generatorStore';

export default { commonStore, generatorStore };



// WEBPACK FOOTER //
// ./src/stores/stores.js